import React from "react";
import { ActionAlert } from "../../../../components/ActionAlert";
import { LoadingButton } from "../../../../components/LoadingButton";
import { WizardContext } from "../../WizardContext";
import { redirectToStep } from "../../wizard_utils";
import { Alert } from "reactstrap";

export const PayorRequiresAdditionalInformationBranch = () => (
  <WizardContext.Consumer>
    {({ caseId, loading, createFollowupTask, updateStatus }) => (
      <>
        <ActionAlert
          className="mt-3"
          color="warning"
          actions={
            <LoadingButton
              color="warning"
              loading={loading}
              onClick={async () => {
                await updateStatus("missinginfo", "no_docs_clinical_info_or_demographics", false);

                await createFollowupTask(
                  2,
                  "Follow up on Missing Info",
                  false,
                  `Follow up task created. Please complete the initial Missing Information outreach for Case ${caseId}`,
                  false
                );

                redirectToStep("prior_auth", "missinginfo_followup", caseId);
              }}
            >
              Ok
            </LoadingButton>
          }
        >
          The case will be moved to <strong>Missing Information</strong> and a follow up task will be created for <strong>2 days</strong>{" "}
          from today.
        </ActionAlert>

        <Alert color="danger">
          <strong>Note:</strong> please complete the initial Missing Information outreach
        </Alert>
      </>
    )}
  </WizardContext.Consumer>
);
